import React, { useContext, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Content from './components/content/Content';
import Header from './components/header/Header';
import { ThemeProvider } from './providers';
import { ThemeContext } from "./providers";
import { display } from '@mui/system';
import { CopyAllOutlined, CopyrightOutlined } from '@mui/icons-material';
import "./App.css"

function App() {

  return (
    <ThemeProvider>
      <BrowserRouter>
        <div
          // style={createStyle(theme)}
          className="app"
        >
          <div
            style={{
              flex: "0 1 auto"
            }}
          >
            <Header />
          </div>

          <div
            style={{
              flex: "1 0 auto",
              display:"flex"
            }}
          >
            <Content />
          </div>

          <div
            id="footer"
            style={{
              flex: "0 1 40px",
              display:"flex",
              justifyContent:"center",
              alignItems:"center"
            }}
          >
            <CopyrightOutlined style={{marginRight:'0.1em'}} /> 2026 <a className="copyright-link" href="https://nicgauer.com/">Nic Gauer</a>
          </div>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
